import { useState } from "react";
import { Star, ChevronDown } from "lucide-react";

export function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function ScrollingStrip({ items, renderItem, speed = 40, bg = "bg-slate-50", border = true }) {
  const doubled = [...items, ...items];
  return (
    <div className={`${bg} ${border ? "border-y border-slate-100" : ""} py-4 overflow-hidden`}>
      <style>{`
        @keyframes marquee { from { transform: translateX(0) } to { transform: translateX(-50%) } }
        .marquee-track { display: flex; width: max-content; animation: marquee ${speed}s linear infinite; }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <div key={i} className="flex-shrink-0 mx-3">{renderItem(item, i)}</div>
        ))}
      </div>
    </div>
  );
}

export function Stars() {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
    </div>
  );
}

export function FAQItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden">
      <button onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-slate-50 transition-colors">
        <span className="text-sm font-semibold text-slate-800 pr-4">{item.q}</span>
        <ChevronDown className={`w-4 h-4 text-slate-400 flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-5 pb-4">
          <p className="text-sm text-slate-600 leading-relaxed">{item.a}</p>
        </div>
      )}
    </div>
  );
}
